/**
 * description:
 * Full-bleed photo hero for the homepage with a text overlay,
 * matching the retro redesign mock.
 */
import { Box, Typography } from "@mui/material";
import EyebrowLabel from "../../../utils/EyebrowLabel";
import { mustard } from "../../../styles.tsx";

const Hero = () => {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "420px", sm: "560px", md: "100vh" },
        display: "flex",
        alignItems: "flex-end",
        overflow: "hidden",
        backgroundImage: 'url(/pictures/FUNDAY2026.png)',
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0) 60%)",
        }}
      />
      <Box sx={{ position: "relative", zIndex: 1, p: { xs: "24px", sm: "48px" }, width: "100%" }}>
        <EyebrowLabel color={mustard} sx={{ textShadow: "0 2px 10px rgba(0,0,0,0.6)" }}>
          What's good FASA fam?
        </EyebrowLabel>
        <Typography
          variant="h1"
          sx={{
            color: "background.default",
            textShadow: "0 4px 18px rgba(0,0,0,0.65)",
            mt: "8px",
          }}
        >
          About Us
        </Typography>
      </Box>
    </Box>
  );
};

export default Hero;
